import { z } from 'zod';

const envSchema = z.object({
  VITE_REGION: z.enum(['development', 'us', 'cn']),
  VITE_DOMAIN: z.string().url(),
  VITE_PLAYGROUND_DOMAIN: z.string().url(),
  VITE_FORUM_DOMAIN: z.string().url(),
  VITE_CDN_DOMAIN: z.string().url(),
  VITE_GA_MEASUREMENT_ID: z.string().default(''),
});

const parsedEnv = envSchema.parse(import.meta.env);

function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function getHost(url: string) {
  return new URL(url).host;
}

const siteUrl = trimTrailingSlash(parsedEnv.VITE_DOMAIN);
const playgroundUrl = trimTrailingSlash(parsedEnv.VITE_PLAYGROUND_DOMAIN);
const forumUrl = trimTrailingSlash(parsedEnv.VITE_FORUM_DOMAIN);
const cdnUrl = trimTrailingSlash(parsedEnv.VITE_CDN_DOMAIN);
const gaMeasurementId = parsedEnv.VITE_GA_MEASUREMENT_ID.trim();

export const env = {
  ...parsedEnv,
  siteUrl,
  playgroundUrl,
  forumUrl,
  cdnUrl,
  siteHost: getHost(siteUrl),
  playgroundHost: getHost(playgroundUrl),
  forumHost: getHost(forumUrl),
  cdnHost: getHost(cdnUrl),
  gaMeasurementId,
  hasGaMeasurementId: gaMeasurementId.length > 0,
  defaultLocale: parsedEnv.VITE_REGION === 'cn' ? 'zh' : 'en',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  isDevelopmentMode: parsedEnv.VITE_REGION === 'development',
  isCn: parsedEnv.VITE_REGION === 'cn',
  isUs: parsedEnv.VITE_REGION === 'us',
};

export type AppEnv = typeof env;
export type AppRegion = AppEnv['VITE_REGION'];
